import { useUser, useDocument } from '@sb-konzept/firebase-hooks'

export default function useUserData() {
  const { user, authenticating } = useUser()
  const doc = useDocument(`users/${user?.uid}`, { withRef: true })
  return { ...doc, uid: user?.uid, authenticating, currentUser: user }
}
